<nz-upload nzType="drag" [nzMultiple]="false"
  [nzAction]="baseUrl + 'media/UploadFile?isImage=' + isImage + '&' + urlSuffix"
  (nzChange)="fileUploadedSuccessfully($event);">
  <p class="ant-upload-drag-icon">
    <i nz-icon nzType="inbox"></i>
  </p>
  <p class="ant-upload-text">
    {{'Click or drag file to this area to upload' | locale }}</p>
  <p class="ant-upload-hint">
    {{'Support for a single upload.' | locale}}
  </p>
</nz-upload>
